module.exports = __webpack_public_path__ + "38bd054c9a75d8a7c5f8ebf3ef23860e.jpg";